<template>
<div>
  <va-modal
    v-model="showTagLeadModal"
    id="tagLeadModal"
    ref="tagLeadModal"
    :okDisabled="!canClose"
    :hideDefaultActions="true"
    @cancel="closeTagList"
    title="">
    <div slot="header">
      <p style="font-size:18px;"><b>{{$t('tags.lead_tag.title', {name: selectedLead.name})}}</b></p>
    </div>
    <div>
      <h6 class="pb-2">{{header.title}}&nbsp;
        <a class="pull-right" href="#" @click.prevent="toggleActiveView">
          <i class="title__icon-label" :class="header.icon"></i>
        </a>
      </h6>
      <transition name="slide-fade" mode="out-in">
        <div :key="1" v-if="isAddingTag" class="pt-2">
          <tag-form
            v-bind="tagFormProps"
            @newTagAdded="tagWasAdded">
          </tag-form>
        </div>
        <div :key="2" v-else>
          <div class="form-group" style="margin-bottom:1.25rem;">
            <div class="input-group clearable-filter">
              <multiselect
                v-model="leadTags"
                :options="tags"
                track-by="id"
                label="name"
                select-label=""
                deselect-label="×"
                placeholder="---"
                :searchable="true"
                :allow-empty="true"
                :multiple="true"
                :limit="5">
                <span slot="noResult">{{'patients.noResults'| translate}}</span>
                <template slot="tag" slot-scope="{ option, remove }">
                  <span class="custom__tag">
                    <span>{{ option.name }}&nbsp;
                      <span v-if="option.visibility"> <i class="fa fa-users" style="color: white;"></i></span>
                      <span v-else><i class="fa fa-user" style="color: white;"></i></span>
                    </span>
                    <i @click="remove(option)" aria-hidden="true" tabindex="1" class="custom__tag-icon"></i>
                  </span>
                </template>
                <template slot="option" slot-scope="props">
                  <span class="option__name">{{ props.option.name }}</span>
                  <i v-if="props.option.image" class="option__image" :class="props.option.image"></i>
                </template>
                <template slot="clear" slot-scope="props">
                  <div class="multiselect__clear" v-if="leadTags.length" @mousedown.prevent.stop="clearEntityFilter(props.search)"></div>
                </template>
              </multiselect>
            </div>
          </div>

          <div class="d-flex justify-content-center">
            <button
              class="btn btn-primary btn-micro"
              @click="associateLeadTags()"
              :disabled="isSubmiting">
              {{$t('modals.defaults.button_save')}}
            </button>
          </div>
        </div>
      </transition>
    </div>
  </va-modal>
  </div>
</template>
<script>
import TagForm from './TagForm'
import Multiselect from 'vue-multiselect'

export default {
  props: {
    selectedLead: {
      type: Object,
      required: true
    },
    tags: {
      type: Array,
      required: false,
      default: () => {
        return []
      }
    },
    selectedTags: {
      type: Array,
      required: false
    }
  },
  components: {
    TagForm,
    Multiselect
  },
  data () {
    return {
      showTagLeadModal: false,
      tagFormProps: null,
      canClose: true,
      leadTags: JSON.parse(JSON.stringify(this.selectedTags)),
      // leadTags: this.selectedTags,
      isAddingTag: false,
      isSubmiting: false,
      animated: false
    }
  },
  mounted () {
    this.showTagLeadModal = true
  },
  methods: {
    toggleActiveView: function () {
      this.isAddingTag = !this.isAddingTag
      this.animated = !this.animated
    },
    associateLeadTags: function () {
      this.isSubmiting = true
      this.$http({
        url: `${this.$store.state.evollead_server}/leads/${this.selectedLead.id}/tags`,
        method: 'POST',
        data: { tags: this.leadTags.map(tag => tag.id) }
      }).then((response) => {
        let data = {
          tags: response.data.data,
          lead: this.selectedLead
        }
        this.$emit('tagsWereAssociatedToLead', data)
        this.$refs.tagLeadModal.cancel()
      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        this.isSubmiting = false
      })
    },
    clearEntityFilter: function () {
      this.leadTags = []
    },
    tagWasAdded: function (tag) {
      this.tags.push(tag)
      this.leadTags.push(tag)
      this.toggleActiveView()
    },
    closeTagList: function () {
      this.$emit('closeTagLeadModal')
    }
  },
  computed: {
    header: function () {
      return {
        icon: this.isAddingTag ? 'fa fa-times' : 'fa fa-plus',
        title: this.isAddingTag ? this.$t('tags.add') : this.$t('tags.title')
      }
    }
  }
}
</script>

<style lang="scss">
.multiselect .multiselect__tag {
  background-color: #29c4a9;
}

.multiselect .multiselect__option--highlight {
  background-color: #29c4a9;
}

.multiselect .multiselect__option--highlight::after {
  background-color: #29c4a9;
}

.multiselect .multiselect__option--selected {
  background-color: #d9d9d9;
}

.multiselect .multiselect__option--selected.multiselect__option--highlight {
  background-color: #e34a4a;
}

.multiselect .multiselect__option--selected.multiselect__option--highlight::after {
  background-color: #e34a4a;
}

.custom__tag {
  position: relative;
  display: inline-block;
  padding: 4px 26px 4px 10px;
  border-radius: 5px;
  margin-right: 10px;
  color: #fff;
  line-height: 1;
  background: #29c4a9;
  margin-bottom: 5px;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  cursor: pointer;
}

.custom__tag-icon {
  cursor: pointer;
  margin-left: 7px;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  font-weight: 700;
  font-style: normal;
  width: 22px;
  text-align: center;
  line-height: 22px;
  -webkit-transition: all .2s ease;
  transition: all .2s ease;
  border-radius: 5px;
}

.custom__tag-icon:focus, .custom__tag-icon:hover {
  background: #21ab93;
}

.custom__tag-icon:after {
  content: "\D7";
  color: #266d4d;
  font-size: 14px;
}

.custom__tag-icon:focus:after, .custom__tag-icon:hover:after {
  color: #fff;
}

.multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
  background: #21ab93 !important;
}

.multiselect__clear {
  position: absolute;
  right: 33px;
  height: 30px;
  width: 30px;
  display: block;
  cursor: pointer;
  z-index: 2;
}

.multiselect__clear:after, .multiselect__clear:before {
  content: "";
  display: block;
  position: absolute;
  width: 3px;
  height: 12px;
  background: #C0C0C0;
  top: 15px;
  right: 4px;
}

.multiselect__clear:after {
  transform: rotate(-45deg);
}

.multiselect__clear:before {
    transform: rotate(45deg);
}

.clearable-filter .multiselect__tags {
  padding-right: 50px;
}

.cleardates-icon {
  color: #C0C0C0 !important;
  background-color: white;
  cursor: pointer;
  margin-left: 7px;
  margin-right: 4px;
  margin-top: 33px;
  margin-bottom: 2px;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  font-style: normal;
  width: 22px;
  text-align: center;
  line-height: 22px;
  border-radius: 5px;
}

.taglead__label {
  justify-content: normal;
  font-size: 0.6rem;
  color: #29c4a9;
  font-weight: 600;
  text-transform: uppercase;
  top: -0.6rem;
  left: 0;
  margin-bottom: 0;
}

.tag__lead a {
  font-size: 0.9rem;
  text-transform: uppercase;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all .2s ease;
}
.slide-fade-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active-appointments below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

.rotate{
    -moz-transition: all .2s linear;
    -webkit-transition: all .2s linear;
    transition: all .2s linear;
}

.rotate.flip_up{
    -moz-transform:rotate(180deg);
    -webkit-transform:rotate(180deg);
    transform:rotate(180deg);
}

.rotate.flip_down{
    -moz-transform:rotate(-180deg);
    -webkit-transform:rotate(-180deg);
    transform:rotate(-180deg);
}

.title__icon-label{
  font-size: 25px;
}

#tagLeadModal .va-modal__inner {
  overflow: visible;
}

</style>
